import { HeadItemType } from 'components/Table'

const headColumns: HeadItemType[] = [
  { label: '', columnName: '', sortable: false },
  {
    label: 'Causa',
    columnName: 'Causa',
    sortable: true
  },
  { label: 'Solicitação', columnName: 'DataSolicitacao', sortable: true },
  {
    label: 'SAP cliente',
    columnName: 'CodigoSapCliente',
    sortable: true
  },
  {
    label: 'Razão social',
    columnName: 'RazaoSocial',
    sortable: true
  },
  {
    label: 'OV portal',
    columnName: 'NumeroOrdemVendaPortal',
    sortable: true
  },
  {
    label: 'Cond. pgmto.',
    columnName: 'CondicaoPagamento',
    sortable: true
  },
  {
    label: 'Prazo devido',
    columnName: 'PrazoDevido',
    sortable: true
  },
  {
    label: 'Prazo aplicado',
    columnName: 'PrazoAplicado',
    sortable: true
  },
  {
    label: 'Desc. devido',
    columnName: 'ValorDescontoMaximo',
    sortable: true
  },
  {
    label: 'Desc. aplicado',
    columnName: 'ValorDescontoAplicado',
    sortable: true
  },
  {
    label: 'Desc. excedente',
    columnName: 'ValorDescontoExcedente',
    sortable: true
  },
  { label: 'Aprovador', columnName: 'Aprovador', sortable: true },
  { label: 'Aprovação', columnName: 'DataAprovacao', sortable: true },
  {
    label: 'Qtd. pares',
    columnName: 'QuantidadePares',
    sortable: true
  },
  {
    label: 'Tipo de OV',
    columnName: 'TipoOrdemVenda',
    sortable: true
  },
  {
    label: 'F.L.',
    columnName: 'ForaDeLinha',
    sortable: true
  },
  {
    label: 'Mês cota',
    columnName: 'MesCota',
    sortable: true
  },
  {
    label: 'Ações',
    columnName: 'acoes',
    actionsLabel: true,
    sortable: false
  }
]

export default headColumns
